export default __webpack_public_path__ + "images/b89e593ecd872904241dc73b71df2e41-logo-dark.svg";